import React, { useEffect, useState } from 'react';
import { UAlertMessage, UButton, UCheckBox, UModal } from 'ubs-framework';
import { sendData } from '../../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import useSocket from '../../common/useSocket';
import { copyLink, Decryption, showToastError, showToastSuccess } from 'ubs-framework/v2/common/function';
import OtpInput from 'react-otp-input';
import Layout from '../../../components/layout/Layout';
import { useHistory } from 'react-router-dom';
import AppHeader from '../../common/components/app-header';
import * as Icon from 'ubs-icons';
import { COLOR } from 'ubs-framework/src/constant';
import { withRouter } from '../../../common/hocs/routing-hoc';
import { Encryption } from '../../../common/functions';
import UPopup from 'ubs-framework/src/UPopup';

const SetUpMultiFactor = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const _LID = useSelector(e => e?.common?.logInDetails)
    const _AD = useSelector(e => e?.common?.authData)
    const [fieldValue, setFieldValue] = useState({
        isEmailMFA: false,
        isAuthenticatorAppMFA: false,
    })
    const [open, setOpen] = useState(null)
    const [generatedData, setGeneratedData] = useState({
        MFAQrCode: '',
        MFASecretKey: '',
        recoveryCode: ''
    })
    const [validateOTP, setValidateOTP] = useState('');
    const [verifyOTP, setVerifyOTP] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handle = {
        checkbox: (e) => {
            const {name, checked} = e.target
            setFieldValue({
                ...fieldValue,
                [name]: checked,
            })
        },
        generateQRCode: (e) => {
            e.preventDefault()
            e.stopPropagation()
            sendData(dispatch, 'hrms|master|MFA|generateQRCode', {})
        
        },
        save: (e) => {
            e.preventDefault() 
            e.stopPropagation()
            let params = {
                MFA: {
                    isEmailMFA: fieldValue?.isEmailMFA ?? false,
                    isAuthenticatorAppMFA: fieldValue?.isAuthenticatorAppMFA ?? false,
                    MFAQrCode: fieldValue?.isAuthenticatorAppMFA ? generatedData?.MFAQrCode : null,
                    MFASecretKey: fieldValue?.isAuthenticatorAppMFA ? generatedData?.MFASecretKey : null,
                    recoveryCode: fieldValue?.isAuthenticatorAppMFA ? generatedData?.recoveryCode : null,
                }
            }
            sendData(dispatch, 'hrms|master|MFA|setup', params)
        }
    }

    useEffect(() => {
        if (validateOTP?.length === 6) {
            sendData(dispatch, 'hrms|master|MFA|verify', {
                otp: validateOTP,
                MFASecretKey: generatedData?.MFASecretKey,
            })
        }
    }, [validateOTP])

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'hrms|master|MFA|read':
                    if (res?.data?.MFA) {
                        setFieldValue({
                            ...fieldValue,
                            isEmailMFA: res?.data?.MFA?.isEmailMFA,
                            isAuthenticatorAppMFA: res?.data?.MFA?.isAuthenticatorAppMFA,
                        })
                    }
                    break;
                case 'hrms|master|MFA|generateQRCode':
                    setGeneratedData({
                        ...generatedData,
                        MFAQrCode: res?.data?.MFAQrCode,
                        MFASecretKey: res?.data?.MFASecretKey,
                        recoveryCode: res?.data?.recoveryCode
                    });
                    break;
                case 'hrms|master|MFA|verify':
                    setVerifyOTP(res?.data?.success);
                    if (res?.data?.success) showToastSuccess('OTP verified successfully')
                    else showToastError('Invalid OTP')
                    break;
                case 'hrms|master|MFA|setup':
                    history.push('/login')
                    showToastSuccess('Multi-Factor Authentication Setup Successfully')
                    break;
                default:
                    return true;
            }
        } else {
            setErrorMsg(res?.error?.message)
            switch (res?.code) {
                case 401:
                    history.push('/login')
                    break;
                default:
                    return true;
            }
        }
    })

    useEffect(() => {
        refresh();
        sendData(dispatch, 'hrms|master|MFA|read', {})
        return () => off();
    }, [])

    useEffect(() => {
        if(_AD ? false : (!_LID?.identifier || !_LID?.password)) {
            history.push('/login')
        }
    }, [_LID, _AD])

    return (
    <Layout module="setupMultiFactor">
        <div className="u_account-form u_two-fa-setup">
            <AppHeader header="Setup Multi-Factor Authentication"/>
            <div className="u_mt-24">
                {(_AD?.email || _LID?.email) && <div className="u_w-full">
                    <UCheckBox
                        id="isEmailMFA"
                        label="With work email"
                        checked={fieldValue?.isEmailMFA}
                        name="isEmailMFA"
                        onChange={handle.checkbox}
                        className="u_mb-16"
                    />
                </div>}
                <div className="u_w-full">
                    <UCheckBox
                        id="isAuthenticatorAppMFA"
                        label="With Google Authenticator App"
                        checked={fieldValue?.isAuthenticatorAppMFA}
                        name="isAuthenticatorAppMFA"
                        onChange={handle.checkbox}
                        className="u_mb-16"
                    />
                </div>
                {fieldValue?.isAuthenticatorAppMFA && <div>
                    <div className="">
                        <button type="button" className="u_btn u_btn__white u_generate-qr-code u_mb-16" onClick={(e) => handle.generateQRCode(e)}>
                            <Icon.QRCode fill={COLOR.u_blue} size={16} className='u_mr-12'/>
                            Generate QR Code
                        </button>
                    </div>
                    {generatedData?.MFAQrCode && generatedData?.MFASecretKey && <div className="u_mt-15">
                        {/* QR Code */}
                        <div className='u_flex u_content-center'>
                            <img src={generatedData?.MFAQrCode} alt="QR Code" className='u_b-light' />
                        </div>
                        <div className='u_text-center u_my-16'>
                            <p className='u_color-blue u_cp' onClick={() => setOpen(true)}>Can't scan it?</p>
                        </div>

                        {/* OTP */}
                        <div className={`u_otp ${errorMsg ? 'u_mb-15' : 'u_mb-30'}`}>
                            <OtpInput
                                value={validateOTP}
                                onChange={(e) => setValidateOTP(e)}
                                isInputNum={true}
                                containerStyle={'u_otp-container'}
                                inputStyle={'u_otp-input'}
                                numInputs={6}
                                shouldAutoFocus={true}
                                separator={<span> </span>}
                            />
                        </div>
                    </div>}
                    
                    {errorMsg?.length !== 0 && <p className="u_error-message">{errorMsg ?? ''}</p>}
                </div>}
                <div className="u_block u_relative u_w-full">
                    <UButton type="save" varient="blue" disabled={fieldValue?.isAuthenticatorAppMFA ? !verifyOTP : !fieldValue?.isEmailMFA} cn={`u_account-btn u_cp u_setUp-btn`} onClick={handle.save} />
                </div>

                {fieldValue?.isAuthenticatorAppMFA && generatedData?.recoveryCode && <div className='u_my-16 u_flex-align'>
                    <p className='u_color-title u_mr-8' style={{fontWeight: 700}}>Recovery Code : </p>
                    <div className="u_flex-align u_recovery-code" onClick={() => copyLink(generatedData?.recoveryCode, 'Recovery Code')}>
                        <p className="u_color-title u_py-10 u_px-15 u_cp">
                            {generatedData?.recoveryCode ?? ''}
                        </p>
                        <div className='u_copy-code'>
                            <UPopup
                                params={{className: 'u_tooltip'}}
                                desc={<span>Copy Recovery Code</span>}
                            >
                                <span className="u_cp u_lh-0">
                                    <Icon.Copy size={14} fill={COLOR.u_blue}/>
                                </span>
                            </UPopup>
                        </div>
                    </div>
                </div>}

                {fieldValue?.isAuthenticatorAppMFA && generatedData?.recoveryCode && <div className="u_mt-20">
                    <UAlertMessage danger full>
                        <strong>Important Note : </strong>
                        <span className="u_color-title">
                            If your authenticator app is unavailable or you’ve removed the MFA account, simply use your recovery code to regain access.
                        </span>
                    </UAlertMessage>
                </div>}
            </div>
        </div>

        {open && <UModal
            open={open}
            maxWidth={600}
            onClose={() => setOpen(null)}
            header={<h4>How it work?</h4>}
        >
            <div className="u_p-15">
                <p className="u_color-title u_mb-8">1. Open the Google Authenticator app on your phone.</p>
                <p className="u_color-title u_mb-8">2. Tap the <strong>+</strong> button.</p>
                <p className="u_color-title u_mb-8">3. Choose <strong>"Enter a setup key"</strong>.</p>
                <p className="u_color-title u_mb-8">
                    5. Enter the setup key:
                    <div className="u_flex-align" onClick={() => copyLink(generatedData?.MFASecretKey, 'Setup key')}>
                        <p className="u_color-title u_p-10 u_cp">
                            {generatedData?.MFASecretKey ?? ''}
                        </p>
                        <div className=''>
                            <UPopup
                                params={{className: 'u_tooltip'}}
                                desc={<span>Copy Setup key</span>}
                            >
                                <span className="u_cp u_lh-0">
                                    <Icon.Copy size={14} fill={COLOR.u_blue}/>
                                </span>
                            </UPopup>
                        </div>
                    </div>
                </p>
            </div>
        </UModal>}
    </Layout>
    )
};

export default SetUpMultiFactor;
